import { render, staticRenderFns } from "./cookies-policy-message.vue?vue&type=template&id=0626820c&"
import script from "./cookies-policy-message.vue?vue&type=script&lang=js&"
export * from "./cookies-policy-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports